"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultStampdutyState = void 0;
exports.defaultStampdutyState = {
    headerSection: {
        translate: {
            title: 'Hong Kong Stamp Duty Summary',
            paragraph: 'This table shows all current stamp duties imposed by the Hong Kong government on property purchases made within the region'
        }
    },
    contentSection: {
        stampDutyList: {
            regularStampDuty: {
                name: 'REGULAR STAMP DUTY',
                transactionsAffected: 'All',
                responsibleForPayment: 'Purchaser',
                effectiveDates: 'Ongoing',
                paymentAmount: {
                    purchaseAmountOrValue: 'PURCHASE AMOUNT OR CONSIDERATION VALUE <i>(whichever is higher)</i>:',
                    items: [
                        {
                            range: 'Under $2,000,000',
                            amount: '$100'
                        },
                        {
                            range: '$2,000,000 - $2,351,760',
                            amount: '$100 + 10% In <br />excess of $2M'
                        },
                        {
                            range: '$2,351,760 - $3,000,000',
                            amount: '1.50%'
                        },
                        {
                            range: '$3,000,000 - $3,290,320',
                            amount: '$45,000 + 10% In <br />excess of $3M'
                        },
                        {
                            range: '$3,290,320 - $4,000,000',
                            amount: '2.25%'
                        },
                        {
                            range: '$4,000,000 - $4,428,570',
                            amount: '$90,000 + 10% In <br />excess of $4M'
                        },
                        {
                            range: '$4,428,570 - $6,000,000',
                            amount: '3%'
                        },
                        {
                            range: '$6,000,000 - $6,720,000',
                            amount: '$180,000 + 10% In <br />excess of $6M'
                        },
                        {
                            range: '$6,720,000 - $20,000,000',
                            amount: '3.75%'
                        },
                        {
                            range: '$20,000,000 - $21,739,120',
                            amount: '$750,000 + 10% In <br />excess of $20M'
                        },
                        {
                            range: 'Over $21,739,120',
                            amount: '4.25%'
                        }
                    ]
                },
                exemptions: 'None'
            },
            specialStampDuty: {
                name: 'SPECIAL STAMP DUTY (SSD)',
                transactionsAffected: 'Properties purchased after SSD introduction',
                responsibleForPayment: 'Both Vendor and Purchaser (negotiable)',
                effectiveDates: [
                    '(A) Properties purchased between 20-Nov-2010 and 26-Oct-2012',
                    '(B) Properties purchased after 27-Oct-2012'
                ],
                paymentAmount: [
                    {
                        item: '(A) Properties sold within:',
                        subItems: ['6 months - 15%', '1 year - 10%', '2 years - 5%']
                    },
                    {
                        item: '(B) Properties sold within:',
                        subItems: ['6 months - 20%', '1 year - 15%', '2 years - 10%']
                    }
                ],
                exemptions: 'Units purchased by Seller before 20-Nov-2010 or sold after 2-3 years of purchase subject to (A) and (B) above'
            },
            buyersStampDuty: {
                name: "BUYER'S STAMP DUTY",
                transactionsAffected: 'Properties purchased by company or non-permanent resident',
                responsibleForPayment: 'Purchaser',
                effectiveDates: 'From Oct-27-2012',
                paymentAmount: 'Non-Permanent resident or Company Buyer - 15%',
                exemptions: 'Permanent HKID Card holders'
            },
            adValoremStampDuty: {
                name: 'AD VALOREM STAMP DUTY<br />(inclusive of Regular Stamp Duty)',
                transactionsAffected: 'Properties purchased by non first-time buyer',
                responsibleForPayment: 'Purchaser',
                effectiveDates: 'From 5-Nov-2016',
                paymentAmount: 'Fixed Rate of 15%',
                exemptions: 'First time buyers and those not in possession of another property at the time of purchase'
            }
        },
        translate: {
            transactionsAffected: 'Transactions Affected',
            responsibleForPayment: 'Responsible for Payment',
            effectiveDates: 'Effective Dates',
            paymentAmount: 'Payment Amount',
            exemptions: 'Exemptions'
        }
    },
    footerSection: {
        translate: {
            lastUpdatedDate: 'Last Updated Date: 15 Nov 2016',
            disclaimer: 'DISCLAIMER: The information contained herein has been gathered from sources we deem reliable. We have no reason to doubt its accuracy but we do not guarantee it. Please note that the current stamp duties applied by the government are considered provisional and may be subject to change.  The latest stamp duty information can be found on the <a title="stampduty" href="http://www.gov.hk/en/residents/taxes/stamp/stamp_duty_rates.htm">Hong Kong government website.</a> All information is provided strictly for reference and should be verified prior to purchase or lease.'
        }
    }
};
